/* eslint-disable no-lonely-if */
/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import { TOUR_SEARCH_REGIONS_INDEX } from './Constants/Indexes';

// import HttpsAgent from 'https-agent';

// const agent = new HttpsAgent({
//   rejectUnauthorized: false,
// });

export function compareName(a, b) {
  const nameA = a.name.toUpperCase();
  const nameB = b.name.toUpperCase();

  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  return 0;
}

const agent = '';

const REACT_APP_ES_USER = 'elastic';
const REACT_APP_ES_PASSWORD = 'MagicWord';

function post(index, query) {
  return axios.post(`/${index}/_search`, query, {
    auth: {
      username: REACT_APP_ES_USER,
      password: REACT_APP_ES_PASSWORD,
    },
    httpsAgent: agent,
  });
}

export function getAllCountries(index) {
  const query = {
    from: 0,
    size: 1000,
    query: {
      bool: {
        must: [
          {
            match: {
              type: 'country',
            },
          },
        ],
      },
    },
  };

  return axios.post(`/${index}/_search`, query, {
    auth: {
      username: REACT_APP_ES_USER,
      password: REACT_APP_ES_PASSWORD,
    },
    httpsAgent: agent,
  });
}

export function getRegionsByCountryId(destinatinId, index) {
  const query = {
    from: 0,
    size: 1000,
    query: {
      bool: {
        must: [
          {
            bool: {
              should: [{ term: { type: 'region' } }],
            },
          },
          {
            match: {
              countryId: destinatinId,
            },
          },
        ],
      },
    },
  };

  return axios.post(`/${index}/_search`, query, {
    auth: {
      username: REACT_APP_ES_USER,
      password: REACT_APP_ES_PASSWORD,
    },
    httpsAgent: agent,
  });
}

export function getResortsByCountryId(destinatinId, index) {
  const query = {
    from: 0,
    size: 1000,
    query: {
      bool: {
        must: [
          {
            bool: {
              should: [
                { term: { type: 'region' } },
                { term: { type: 'subregion' } },
              ],
            },
          },
          {
            match: {
              countryId: destinatinId,
            },
          },
        ],
      },
    },
  };

  return axios.post(`/${index}/_search`, query, {
    auth: {
      username: REACT_APP_ES_USER,
      password: REACT_APP_ES_PASSWORD,
    },
    httpsAgent: agent,
  });
}

export function getResortsByCountryIdAndThen(
  props,
  destinationId,
  selectedFromUrl,
  preselectedResorts,
) {
  const { selectedResorts, changeRegionsOptions } = props;
  getResortsByCountryId(destinationId, TOUR_SEARCH_REGIONS_INDEX).then(
    (res) => {
      const { hits } = res.data;
      if (hits) {
        const resource = hits.hits.map((h) => h._source);

        const regions = resource
          .filter((item) => item.type === 'region')
          .map((item) => ({
            ...item,
            checked: false,
            subregions: resource
              .filter((e) => e.parentregionId === item.id)
              .map((sub) => ({ ...sub, checked: false }))
              .sort(compareName),
            subregionsVisible: false,
          }));

        let resutltMapedToState = regions;

        let selRes;
        if (selectedFromUrl && selectedFromUrl.length > 0) {
          selRes = selectedFromUrl;
        } else {
          if (preselectedResorts && preselectedResorts.length > 0) {
            selRes = preselectedResorts;
          } else {
            selRes = selectedResorts;
          }
        }

        selRes
          // eslint-disable-next-line eqeqeq
          .filter((e) => e.countryId == destinationId) // country id type in initial country
          .forEach((selected) => {
            resutltMapedToState = resutltMapedToState.map((reg) => {
              if (reg.id === selected.id) {
                const selectedSubr = selected.subregions;
                let sub = reg.subregions;

                if (selectedSubr) {
                  sub = sub.map((e) => {
                    const sel = selectedSubr.filter((i) => i.id === e.id);
                    if (sel.length > 0 && sel[0].checked) {
                      return {
                        ...e,
                        checked: true,
                      };
                    }

                    return e;
                  });
                } else {
                  sub = sub.map((e) => ({
                    ...e,
                    checked: true,
                  }));
                }

                return {
                  ...reg,
                  checked: true,
                  subregions: sub,
                  subregionsVisible:
                    sub.length !== sub.filter((e) => e.checked === true).length,
                };
              }

              return reg;
            });
          });

        changeRegionsOptions(resutltMapedToState);
      }
    },
  );
}

export function searchCountries(inputValue, index) {
  const qParam = `*${inputValue}*`;
  const countryQuery = {
    from: 0,
    size: 1000,
    query: {
      bool: {
        must: [
          { query_string: { query: qParam, default_field: 'name' } },
          { match: { type: 'country' } },
        ],
      },
    },
  };

  return axios.post(`/${index}/_search`, countryQuery, {
    auth: {
      username: REACT_APP_ES_USER,
      password: REACT_APP_ES_PASSWORD,
    },
  });
}

export function searchCities(inputValue, countriesResult, isAllCities, index) {
  const qParam = `*${inputValue}*`;

  let cityQuery;
  if (isAllCities) {
    cityQuery = {
      from: 0,
      size: 1000,
      query: {
        bool: {
          must: [
            { query_string: { query: qParam, default_field: 'name' } },
            {
              bool: {
                should: [
                  { term: { type: 'region' } },
                  { term: { type: 'subregion' } },
                ],
              },
            },
          ],
        },
      },
    };
  } else {
    cityQuery = {
      from: 0,
      size: 1000,
      query: {
        bool: {
          must: [
            { match: { type: 'region' } },
            { match: { countryId: countriesResult[0].id } },
          ],
        },
      },
    };
  }

  return axios.post(`/${index}/_search`, cityQuery, {
    auth: {
      username: REACT_APP_ES_USER,
      password: REACT_APP_ES_PASSWORD,
    },
  });
}

export function searchHotels(inputValue, index) {
  const qParam = `*${inputValue}*`;

  const poximity = {
    from: 0,
    size: 20,
    query: {
      bool: {
        must: [
          { query_string: { query: qParam, default_field: 'name' } },
          { match: { type: 'hotel' } },
        ],
        should: {
          match_phrase: {
            name: {
              query: qParam,
              slop: 5,
            },
          },
        },
      },
    },
  };

  return axios.post(`/${index}/_search`, poximity, {
    auth: {
      username: REACT_APP_ES_USER,
      password: REACT_APP_ES_PASSWORD,
    },
  });
}

export function getCountryById(countryId, index) {
  const query = {
    from: 0,
    size: 1000,
    query: {
      bool: {
        must: [
          {
            match: {
              type: 'country',
            },
          },
          {
            match: {
              id: countryId,
            },
          },
        ],
      },
    },
  };

  return post(index, query);
}

export function searchHotelsInCountry(inputValue, index, country) {
  const qParam = `*${inputValue}*`;

  const poximity = {
    from: 0,
    size: 20,
    query: {
      bool: {
        must: [
          { query_string: { query: qParam, default_field: 'name' } },
          { match: { type: 'hotel' } },
          { match: { countryId: country } },
        ],
        should: {
          match_phrase: {
            name: {
              query: qParam,
              slop: 5,
            },
          },
        },
      },
    },
  };

  return axios.post(`/${index}/_search`, poximity, {
    auth: {
      username: REACT_APP_ES_USER,
      password: REACT_APP_ES_PASSWORD,
    },
  });
}

export function getHotelsByCountryId(id, index) {
  const q = {
    from: 0,
    size: 100,
    query: { term: { countryId: { value: id } } },
    sort: [{ rating: { order: 'desc' } }],
  };

  return post(index, q);
}

export function getHotelById(hotelId, index) {
  const query = {
    from: 0,
    size: 1000,
    query: {
      bool: {
        must: [
          {
            match: {
              type: 'hotel',
            },
          },
          {
            match: {
              id: hotelId,
            },
          },
        ],
      },
    },
  };

  return post(index, query);
}

// ---------------------------------

export function getResortsByIds(countryId, ids) {
  const query = {
    from: 0,
    size: 1000,
    query: {
      bool: {
        must: [
          { match: { type: 'city' } },
          { match: { parentId: countryId } },
          {
            bool: {
              should: [],
            },
          },
        ],
      },
    },
  };

  ids.forEach((id) => {
    const match = { match: { id } };
    query.query.bool.must[2].bool.should.push(match);
  });

  return axios.post('/th/_search', query, {
    auth: {
      username: process.env.REACT_APP_ES_USER,
      password: process.env.REACT_APP_ES_PASSWORD,
    },
    httpsAgent: agent,
  });
}

export default getResortsByCountryId;
